/*
 * @Author: your name
 * @Date: 2021-01-09 10:10:32
 * @LastEditTime: 2021-07-05 15:27:47
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \media8k_admin\src\assets\script\message.js
 */
import Vue from "vue";
Vue.prototype.$msg = function (msg) {
  Vue.prototype.$message.closeAll();
  msg.showClose === undefined && (msg.showClose = true);
  Vue.prototype.$message({
    showClose: msg.showClose,
    message: msg.message,
    type: msg.type
  });
};


